import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { Typography, Box, Paper, Divider } from '@material-ui/core';
import Filter from '../../../components/Dashboard/Filter/Activity-6level-Date';
import MaterialTable from 'material-table';
import { tableIcons } from '../../../configs/ui/TableConfig';
import Axios from 'axios';
import { useSnackbar } from 'notistack';
import {
   graph_mock,
   multitable_mock,
} from '../../../mockdata/dashboard/mock-graph-6';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import EmptyChart from '../../../components/Dashboard/Chart/EmptyChart';
import DownloadPDFButton from '../../../components/Dashboard/Button/DownloadPDF';
import { useLocation } from 'react-router-dom';
import FileSaver from 'file-saver';
import DownloadExcelButton from '../../../components/Dashboard/Button/DownloadExcel';
import moment from 'moment';

let mock = false;

const useStyles = makeStyles((theme) => ({
   descContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
   },
   loading: {
      height: '300px',
      width: '100%',
      backgroundColor: '#F2F2F2',
      borderRadius: '5px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
   },
   graphsContainer: {
      width: '100%',
      display: 'flex',
   },
   usedPointFlag: {
      width: 30,
      height: 15,
      backgroundColor: '#EC068D',
      borderRadius: '2px',
   },
   remainPointFlag: {
      width: 30,
      height: 15,
      backgroundColor: '#CCCCCC',
      borderRadius: '2px',
   },
   tablesContainer: {
      backgroundColor: 'white',
      height: '100%',
   },
}));

const PointAndRedeem = () => {
   const classes = useStyles();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();
   const [isLoadingGraph, setIsLoadingGraph] = useState(false);
   const [MultiTable, setMultiTable] = useState(null);
   const [isLoadingExcel, setIsLoadingExcel] = useState(false);
   const [isLoadingMultiTable, setIsLoadingMultiTable] = useState(false);
   const [chartData, setChartData] = useState();
   const [filtersData, setFiltersData] = useState();
   const location = useLocation();
   const getChartsOptionsDefault = () => {
      let option = {
         tooltip: {
            trigger: 'axis',
            axisPointer: {
               type: 'cross',
               label: {
                  backgroundColor: '#6a7985',
               },
            },
         },
         legend: {
            data: ['ผู้เข้าใช้งาน'],
         },
         grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true,
         },
         xAxis: [
            {
               name: 'วัน',
               type: 'category',
               boundaryGap: false,
               data: null,
               axisLabel: { rotate: 45 },
            },
         ],
         yAxis: [
            {
               name: 'ครั้ง',
               type: 'value',
            },
         ],
         series: [
            {
               smooth: true,
               name: 'ผู้เข้าใช้งาน',
               type: 'line',
               stack: 'Total',
               areaStyle: {},
               emphasis: {
                  focus: 'series',
               },
               data: null,
            },
         ],
      };
      return option;
   };
   const onFiltersSubmit = (filters) => {
      setFiltersData(filters);
      let payload = {
         divisionList: filters.shortCodes,
         startDate: filters.startDateString,
         endDate: filters.endDateString,
         activityId: filters.activity && filters.activity.activityId,
      };
      if (mock) {
         setIsLoadingGraph(true);
         setTimeout(() => {
            setIsLoadingGraph(false);
            setChartData(graph_mock.graph);
         }, 1000);
      } else {
         setIsLoadingGraph(true);
         Axios.post(
            '/GSB/dashboard/dashboard/GetDepartmentActiviyGraph',
            payload,
         )
            .then((resp) => {
               setChartData(resp.data.graph);
               // enqueueSnackbar('ดึงข้อมูลกราฟสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               setChartData(null);
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(response.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else console.error('site error');
            })
            .finally(() => {
               setIsLoadingGraph(false);
            });
      }
   };
   const mapOptions = (data) => {
      let xAxisDate = data.map((el) => el.dateTimeLabel);
      let activityCount = data.map((el) => el.activityCount);
      let options = getChartsOptionsDefault();
      options.xAxis[0].data = xAxisDate;
      options.series[0].data = activityCount;
      return options;
   };

   const getTopPoint = () => {
      if (mock) {
         setTimeout(() => {
            setMultiTable(multitable_mock.datas);
         }, 100);
      } else {
         setIsLoadingMultiTable(true);
         Axios.get('/GSB/dashboard/dashboard/GetTopActivity')
            .then((resp) => {
               setMultiTable(resp.data.topActivityTables);
               // enqueueSnackbar('ดึงข้อมูลตารางสำเร็จ', { variant: 'success' });
            })
            .catch((e) => {
               if (e.response) {
                  const response = e.response.data;
                  enqueueSnackbar(e.response.data.errorAppMessageTh, {
                     variant: 'error',
                  });
               } else {
                  console.error('site error');
               }
            })
            .finally(() => {
               setIsLoadingMultiTable(false);
            });
      }
   };

   const handleDownloadExcel = () => {
      setIsLoadingExcel(true);
      Axios.get(`/GSB/dashboard/dashboard/GetTopActivity`, {
         responseType: 'blob',
         params: {
            isGenerateReport: true,
         },
      })
         .then((response) => {
            setIsLoadingExcel(false);
            FileSaver.saveAs(
               new Blob([response.data]),
               'ข้อมูลกิจกรรมที่แต่ละหน่วยงานจัดขึ้น.xlsx',
            );
         })
         .catch((err) => {
            enqueueSnackbar('เกิดข้อผิดพลาด กรุณาตรวจสอบข้อมูล', {
               variant: 'error',
            });
         });
   };
   useEffect(() => {
      getTopPoint();
   }, []);
   const costFormat = (value) => {
      return value && new Intl.NumberFormat().format(value);
   };
   return (
      <div>
         <Box margin={'10px 0px'} textAlign={'end'}>
            <DownloadPDFButton
               disabled={isLoadingGraph || isLoadingMultiTable}
               to={() => {
                  localStorage.setItem(
                     'report',
                     JSON.stringify({ filtersData, chartData, MultiTable }),
                  );
                  return {
                     pathname: location.pathname + '/report',
                  };
               }}
            />
         </Box>
         <Paper>
            <Box padding={'10px'}>
               <Typography variant='h5'>
                  ข้อมูลกิจกรรมที่แต่ละหน่วยงานจัดขึ้น
               </Typography>
               <Filter
                  isLoading={isLoadingGraph}
                  onSubmit={onFiltersSubmit}
                  defaultSubmitFirstParams={false}
                  startDate={new Date(moment().subtract(2, 'years'))}
                  endDate={new Date()}
               />
            </Box>
            <Box padding={'10px'}>
               {chartData ? (
                  <ReactECharts
                     option={mapOptions(chartData)}
                     style={{ height: 300, width: '100%' }}
                  />
               ) : (
                  <EmptyChart
                     text={'โปรดระบุตัวกรองด้านบนเพื่อแสดงกราฟ'}
                     show={true}
                     height={300}
                  />
               )}
            </Box>
            <Divider variant='middle' />
            <Box marginTop={'10px'} padding={'10px'}>
               <Box textAlign={'end'}>
                  <DownloadExcelButton
                     isLoading={isLoadingExcel}
                     onClick={handleDownloadExcel}
                  />
               </Box>
               <Box display={'flex'}>
                  {isLoadingMultiTable ? (
                     <div className={classes.loading}>
                        <CircularProgress size={20} />
                     </div>
                  ) : (
                     MultiTable &&
                     MultiTable.map((item, index) => (
                        <Box
                           className={classes.tablesContainer}
                           key={index}
                           marginRight={
                              index !== MultiTable.length - 1 ? '5px' : 0
                           }
                           width={'50%'}
                        >
                           <Box
                              minHeight={100}
                              fontSize={20}
                              fontWeight={'bold'}
                              display={'flex'}
                              justifyContent={'center'}
                              textAlign={'center'}
                              alignItems={'center'}
                           >
                              {item.tableName}
                           </Box>
                           <MaterialTable
                              columns={[
                                 {
                                    field: 'seq',
                                    title: 'ลำดับ',
                                    sorting: false,
                                    width: 10,
                                 },
                                 {
                                    field: 'activityNameTh',
                                    title: 'กิจกรรม',
                                    sorting: false,
                                 },
                                 {
                                    field: 'participateCount',
                                    title: 'ครั้ง',
                                    sorting: false,
                                 },
                              ]}
                              data={item.activities}
                              options={{
                                 paging: false,
                                 showTitle: false,
                                 headerStyle: {
                                    fontWeight: 'bold',
                                    backgroundColor: '#F6F6F6',
                                 },
                                 actionsColumnIndex: -1,
                                 addRowPosition: 'first',
                                 actionsCellStyle: {
                                    color: '#ccc',
                                 },
                                 padding: 'dense',
                                 pageSize: 10,
                                 search: false,
                                 toolbar: false,
                                 draggable: false,
                              }}
                              localization={{
                                 body: {
                                    editRow: {
                                       deleteText:
                                          'ต้องการลบข้อมูลนี้ใช่หรือไม่?',
                                    },
                                 },
                                 header: { actions: 'ตัวจัดการ' },
                              }}
                              icons={tableIcons}
                           />
                        </Box>
                     ))
                  )}
               </Box>
            </Box>
         </Paper>
      </div>
   );
};

export default PointAndRedeem;
